export default __webpack_public_path__ + "static/media/Background_00257.352d92c5.png";